import React from 'react';
import { useIntl } from 'react-intl';
import { Table } from 'semantic-ui-react';
import MarkdownPopup from '@/components/MarkdownPopup';
import NameCell from '@/components/table/NameCell';
import Events from '../hooks/events';

const DatasetAttachmentDescriptionCell = ({
  attachment,
  category,
  code,
  canEdit,
  theme,
}) => {
  const intl = useIntl();
  const showEditDialog = Events.useShowEditDatasetAttachmentDialog(category, { code });
  const { description } = attachment.metadata;
  const editable = canEdit && !description;

  return (
    <>
      {editable && (
        <NameCell
          href="#"
          name={intl.formatMessage({ id: 'click.to.add' })}
          onClick={() => showEditDialog({ attachment })}
        />
      )}
      {!editable && (
        <Table.Cell className="aridhia-markdown-cell-popup td-description">
          <MarkdownPopup content={description} className="td-description" theme={theme} />
        </Table.Cell>
      )}
    </>
  );
};

export default DatasetAttachmentDescriptionCell;
